module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionText),
      expression: "scenario.parameters.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionId', 'questionAudio', 'currentSpeakerQuestion', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question', 'currentEmotionQuestion', 'currentSpeedQuestion')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n          Сгенерировать аудио\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerQuestion),
      expression: "tmp.currentSpeakerQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n              " + _vm._s(speaker.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionQuestion),
      expression: "tmp.currentEmotionQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n              " + _vm._s(emotion.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedQuestion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedQuestion = $event
      }
    }
  }), _vm._v("\n          Скорость: " + _vm._s(_vm.tmp.currentSpeedQuestion) + "\n        ")], 1), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio', {
    ref: 'questionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('loadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio', {
    ref: "questionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Заключение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionText),
      expression: "scenario.parameters.conclusionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.conclusionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "conclusionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('conclusionId', 'conclusionAudio', 'currentSpeakerConclusion', 'generatedConclusionAudio', 'conclusionText', 'conclusionLoading', 'conclusion', 'currentEmotionConclusion', 'currentSpeedConclusion')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.conclusionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n        Сгенерировать аудио\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerConclusion),
      expression: "tmp.currentSpeakerConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n            " + _vm._s(speaker.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionConclusion),
      expression: "tmp.currentEmotionConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n            " + _vm._s(emotion.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedConclusion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedConclusion = $event
      }
    }
  }), _vm._v("\n        Скорость: " + _vm._s(_vm.tmp.currentSpeedConclusion) + "\n      ")], 1), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio', {
    ref: 'conclusionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('conclusionLoadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "conclusionLoadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('conclusionLoadAudio', 'conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion', 'conclusionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio', {
    ref: "conclusionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (this.scenario.parameters.conclusionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'generatedConclusionAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317de15b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/ScenarioQuestionRecognition.vue
// module id = 501
// module chunks = 42